import mock from '../MockConfig';
import boardList from '@crema/services/db/apps/board/boardList';

let boardData = boardList;

mock.onGet('/api/scrumboard/board/').reply((config) => {
  const params = config.params;
  const response = boardData.find((board) => board.id === parseInt(params.id));
  return [200, response];
});

